import { unwrapLink } from '@platejs/link';

import { useContentEditor } from 'common/components/ContentEditor/hooks/useContentEditor';
import { options } from 'common/components/ContentEditor/options';
import { unwrapList } from 'common/components/ContentEditor/utils/editorHelpers';

import { IToolbarButtonProps, ToolbarButton } from './ToolbarButton';

export const ToolbarClearFormat = (props: IToolbarButtonProps) => {
    const editor = useContentEditor();

    return (
        <ToolbarButton
            onMouseDown={(event) => {
                event.preventDefault();

                if (!editor.selection) return;

                editor.tf.removeMarks([
                    options.bold.type,
                    options.italic.type,
                    options.underline.type,
                    options.superscript.type,
                ]);

                unwrapLink(editor);
                unwrapList(editor);

                editor.tf.setNodes({
                    type: options.p.type,
                } as never);
            }}
            {...props}
        />
    );
};
